import { combineReducers } from 'redux';
import loaderCsvFormReducer from './csv-form/reducer';
import loaderXmlFormReducer from './xml-form/reducer';
import {LOADER_FORMAT_SET} from "./actions";

const loaderReducer = combineReducers({
  components: combineReducers({
    csvForm: loaderCsvFormReducer,
    xmlForm: loaderXmlFormReducer
  }),
  shared: (
    state = {
      format: 'csv'
    },
    action
  ) => {
    switch (action.type) {
      case LOADER_FORMAT_SET:
        return {
          ...state,
          format: action.format
        };
      default:
        return state;
    }
  }
});

export default loaderReducer;



// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/reducer.js